import { CATEGORY_NAV_ITEMS } from "./navigation";

export const CATEGORY_BUTTONS = CATEGORY_NAV_ITEMS.map(
  ({ label, image, query, slug, path }) => ({
    label,
    image,
    query,
    slug,
    path,
  }),
);
